import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAssistant } from './AssistantProvider';
import { SparkIcon, SearchIcon, ShieldIcon, LifebuoyIcon } from './icons';

/* Empty-conversation state: spark, prompt, one explainer line, 3 suggestions that send. */
const EmptyState = () => {
  const { t } = useTranslation('assistant');
  const { send } = useAssistant();

  const suggestions = [
    { icon: <SearchIcon />, text: t('Research a company') },
    { icon: <ShieldIcon />, text: t('Is my compliance screening up to date?') },
    { icon: <LifebuoyIcon />, text: t('Report a data issue to support') },
  ];

  return (
    <div className="bra-empty">
      <span className="bra-espark">
        <SparkIcon />
      </span>
      <div className="bra-et">{t('How can I help?')}</div>
      <div className="bra-eb">
        {t(
          'I can research companies, review compliance and ownership, and take you anywhere in Business Radar.'
        )}
      </div>
      <div className="bra-sugg">
        {suggestions.map((s) => (
          <button
            key={s.text}
            type="button"
            className="bra-sug"
            onClick={() => send(s.text)}
          >
            {s.icon}
            <span>{s.text}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default EmptyState;
